import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";
import { Box } from "@mui/material";
function Header() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', p: 2 }}>
      <Box component={"img"} src={logo} sx={{ width: '50%' }} alt="overwatch 2 logo" />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: 2, justifyContent: 'center', alignItems: 'center', gap: 2 }} >
        <NavLink to={"/heroes"}>
          <button className="btn_header">Héros</button>
        </NavLink>
        <NavLink to={"/gamemode"}>
          <button className="btn_header">Modes de jeux</button>
        </NavLink>
        <NavLink to={"/maps"}>
          <button className="btn_header">Maps</button>
        </NavLink>
        <NavLink to={"/carrier"}>
          <button className="btn_header">Ma carrière</button>
        </NavLink>
        <NavLink to={"/builder"}>
          <button className="btn_header">Team builder</button>
        </NavLink>
      </Box>
    </Box>
  );
}

export default Header;
